import React, { useState, useEffect } from "react";
import "./Programs.css";

const ArrowRightIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14" />
    <path d="m12 5 7 7-7 7" />
  </svg>
);

function Programs() {
  const [programsList, setProgramsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadPrograms = () => {
      try {
        const stored = localStorage.getItem("programs");
        if (stored) {
          const parsed = JSON.parse(stored);
          if (Array.isArray(parsed) && parsed.length > 0) {
            setProgramsList(parsed);
          } else {
            setProgramsList(staticDefaults);
          }
        } else {
          setProgramsList(staticDefaults);
        }
      } catch (err) {
        console.error("Failed to load programs from localStorage:", err);
        setError("Could not load programs. Showing defaults.");
        setProgramsList(staticDefaults);
      } finally {
        setLoading(false);
      }
    };

    loadPrograms();
    // Listen for storage changes in case another tab updates programs
    window.addEventListener("storage", loadPrograms);
    return () => window.removeEventListener("storage", loadPrograms);
  }, []);

  return (
    <div className="programs-page-wrapper">
      <section className="programs-hero" style={{
    backgroundImage: "url('/images/bread.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title" style={{
    textAlign: "center"
  }}>Our Programs</h1>
          <div className="hero-breadcrumb">
            <span className="breadcrumb-link">Home</span>
            <span className="breadcrumb-arrow">➔</span>
            <span className="breadcrumb-current">Our Programs</span>
          </div>
        </div>
      </section>

      <section className="programs-section">
        <div className="programs-container">
          {loading ? (
            <div className="loading-state">
              <svg className="spinner" viewBox="0 0 24 24" fill="none">
                <circle className="spinner-bg" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="spinner-fill" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
              </svg>
              <p>Loading programs...</p>
            </div>
          ) : error ? (
            <div className="error-state">{error}</div>
          ) : programsList.length === 0 ? (
            <div className="empty-state">No active programs found.</div>
          ) : (
            <div className="programs-list">
              {programsList.map((program) => (
                <div key={program._id || program.id} className="program-card">
                  <h2 className="program-title">{program.title}</h2>
                  <p className="program-desc">{program.desc}</p>
                  <div className="program-gallery-preview">
                    {program.images?.map((img, idx) => (
                      <div key={idx} className="program-img-wrap">
                        <img
                          src={img}
                          alt={`${program.title} initiative ${idx + 1}`}
                          className="program-img"
                          loading="lazy"
                        />
                      </div>
                    ))}
                  </div>
                  <a href={program.link || "#"} className="program-view-btn">
                    <span>View More</span>
                    <ArrowRightIcon />
                  </a>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

// Fallback static data if localStorage is empty or unreadable
const staticDefaults = [
  {
    id: "education",
    title: "Education Support",
    desc: "We provide scholarships, school supplies, and tuition assistance to underprivileged students. Our programs bridge the gap between potential and opportunity.",
    images: [
      "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=400&q=80",
      "https://images.unsplash.com/photo-1577896851231-70ef18881754?w=400&q=80",
      "https://images.unsplash.com/photo-1588072432836-e10032774350?w=400&q=80",
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=400&q=80"
    ],
    link: "/gallery/education"
  },
  {
    id: "healthcare",
    title: "Healthcare Outreach",
    desc: "Mobile clinics, vaccination drives, and health education camps in rural communities. We ensure medical care reaches those who need it most.",
    images: [
      "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=400&q=80",
      "https://images.unsplash.com/photo-1584515933487-779824d29309?w=400&q=80",
      "https://images.unsplash.com/photo-1532938911079-1b06ac7ceec7?w=400&q=80",
      "https://images.unsplash.com/photo-1551076805-e1869033e561?w=400&q=80"
    ],
    link: "/gallery/healthcare"
  }
];

export default Programs;